import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import ContactForm from "./ContactForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { parseURL } from "../../../sc-utilities";
import * as actions from './store/contactActions';
import History from "../../../../History";
import { hasPermission } from "../../../sc-utilities";
import { CancelToken } from 'axios';

const ContactEdit = props => {
    const { activeCustomerID, loadContact, translations, contact, loadContactInit, updateContact, permissions } = props;
    const [editData, setEditData] = useState({ loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await loadContact({ ActiveCustomerID: activeCustomerID, ContactID: parseURL(window.location.href).contactID }, { cancelToken: requestToken.token })
            setEditData({ loadingData: false })
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            loadContactInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data["Type"] = contact && contact.Type ? contact.Type : '';
        let result = await updateContact({ ...data, ActiveCustomerID: activeCustomerID, ContactID: parseURL(window.location.href).contactID });
        if (result) {
            setEditData({ loadingData: true });
            History.goBack()
        }
    };

    let initialValues = {
        FirstName: contact && contact.FirstName ? contact.FirstName : '',
        LastName: contact && contact.LastName ? contact.LastName : '',
        CompanyName: contact && contact.CompanyName ? contact.CompanyName : '',
        PhoneNumber: contact && contact.PhoneNumber ? contact.PhoneNumber : '',
        Email: contact && contact.Email ? contact.Email : ''
    }

    let formSettings = {
        Validation: {
            FirstName: Yup.string().required("Required"),
            LastName: Yup.string().required("Required"),
            CompanyName: Yup.string().required("Required"),
            PhoneNumber: Yup.string().required("Required"),
            Email: Yup.string().required("Required")
        },
        FormTitle: translations["edit_contact"] || "Edit contact",
        ButtonSubmit: hasPermission(permissions, 'contact_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !editData.loadingData ?
            <ContactForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                permissions={editData.permissions}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        contact: state.client.contact.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateContact: data => dispatch(actions.editContact(data)),
        loadContact: (data, options) => dispatch(actions.loadContact(data, options)),
        loadContactInit: () => dispatch(actions.loadContactInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactEdit);
